<app-ui-dialog-shell
  class="flex min-h-0 w-full flex-auto flex-col"
  title="Transaction Details"
  shellClass="flex h-full min-h-0 w-full flex-col rounded-none border-0 shadow-none sm:h-auto sm:rounded-lg"
  bodyClass="flex min-h-0 w-full flex-1 flex-col overflow-hidden px-3 sm:px-1"
>
  <app-edit-transactions
    class="edit-transaction-dialog"
    [transactions]="transactions"
    (transactionUpdatedEvent)="transactionListEvent($event)"
  />
</app-ui-dialog-shell>
